<mat-slide-toggle [checked]="_quantityHistoryForm.controls.UseQuantityHistory.value" (change)="onUseQuantityHistoryChange($event)">Historie <app-hint-icon hint="Wenn die Historie aktiviert ist können Mengen mit einem Datum versehen werden"></app-hint-icon></mat-slide-toggle>
<br>
<!--<div class="flex justify-between items-center">-->
<!--    <span>{{ _quantityHistoryForm.controls.Quantity.value }}</span>-->
<!--    <button mat-icon-button (click)="editQuantityHistory()">-->
<!--        <fa-icon icon="pencil"></fa-icon>-->
<!--    </button>-->
<!--</div>-->
<app-quantity-history-modal (quantityCalculated)="quantityCalculated($event)" [quantityHistoryForm]="_quantityHistoryForm.controls.QuantityHistory"></app-quantity-history-modal>
<!--<form (submit)="$event.preventDefault(); onQuantityHistorySubmit()" class="flex items-center">-->
<!--    <mat-form-field>-->
<!--        <mat-label></mat-label>-->
<!--        <input type="number" matInput [formControl]="addQuantityHistoryForm" />-->
<!--    </mat-form-field>-->
<!--    <button mat-icon-button type="submit" [disabled]="!addQuantityHistoryForm.value">-->
<!--        <fa-icon icon="plus"></fa-icon>-->
<!--    </button>-->
<!--</form>-->
<!--<button-->
<!--    mat-icon-button-->
<!--    (click)="_quantityHistoryForm.controls.ShowQuantityHistory.setValue(!_quantityHistoryForm.value.ShowQuantityHistory); _quantityHistoryForm.controls.ShowQuantityHistory.markAsDirty()"-->
<!--    [matTooltip]="'Historie ' + (_quantityHistoryForm.value.ShowQuantityHistory ? 'ausblenden' : 'einblenden')"-->
<!--    [disabled]="_quantityHistoryForm.controls.ShowQuantityHistory.disabled"-->
<!--&gt;-->
<!--    <fa-icon [icon]="_quantityHistoryForm.value.ShowQuantityHistory ? 'eye' : 'eye-slash'"></fa-icon>-->
<!--</button>-->
